import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import reportWebVitals from './reportWebVitals';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/open-sans/300.css';
import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/500.css';
import '@fontsource/open-sans/700.css';
import theme from './theme';
import CssBaseline from "@mui/material/CssBaseline";
import ReactGA from "react-ga4";
import initializeI18n from './i18n/config';
import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";
import heLocale from "i18n-iso-countries/langs/he.json";

ReactGA.initialize("G-XRVLNWVPHL");

// Register locales for country names
countries.registerLocale(enLocale);
countries.registerLocale(heLocale);

const root = ReactDOM.createRoot(document.getElementById('root'));
initializeI18n().then(() => {
  root.render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <CssBaseline/>
        <App/>
      </ThemeProvider>
    </React.StrictMode>
  );
});

reportWebVitals(ReactGA.send);
